export function reminderState(card) {
  if (!card || !card.reminder_at || card.reminder_done) return null;
  const due = new Date(card.reminder_at);
  if (isNaN(due.getTime())) return null;
  const now = new Date();
  if (due <= now) return "overdue";
  const day = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  if (day(due) === day(now)) return "today";
  return "upcoming";
}

export function formatDue(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const date = d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
  const time = d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  return `${date} · ${time}`;
}

export function toLocalInput(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function fromLocalInput(v) {
  if (!v) return "";
  const d = new Date(v);
  return isNaN(d.getTime()) ? "" : d.toISOString();
}

export function presetISO(days) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  d.setHours(9, 0, 0, 0);
  return d.toISOString();
}
